import type { UiModule } from '@krp/client-runtime'

import { duplicatesActions } from './actions/registerActions'
import { duplicatesUiReducer, type DuplicatesUiState } from './reducer'
import { duplicatesWindows } from './windows/registerWindows'

export function createDuplicatesUiModule(): UiModule<DuplicatesUiState> {
  return {
    id: 'duplicates',
    reducer: duplicatesUiReducer,
    slices: [{ name: 'selection', lifetime: 'screen', reason: 'выбранная карточка пары до нажатия «Это копия»; пары, проверка и отметки — в кэше запросов, обновление страницы выбор не сохраняет' }],
    windows: duplicatesWindows,
    actions: duplicatesActions,
    persistence: [],
    listeners: [],
  }
}
